import { memo } from 'react'
import { CalendarColumn } from '../styled'
import { ColumnComponentProps } from './types'

function ColumnComponent(props: ColumnComponentProps) {
  return <CalendarColumn style={{ gridAutoRows: `${props.timeSlotHeight}px` }}>{props.children}</CalendarColumn>
}

export const Column = memo(ColumnComponent)
